import React, { Component } from "react"
import { Button, Container, Table, Menu } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import "./footer.scss"
import { SocketMenu } from "./SocketMenu";
import { Link, NavLink, withRouter }                                                                 from "react-router-dom"
import Responsive                                                from "react-responsive"
import { revokeAnalyticsConsent } from 'components/CookieConsent/CookieConsent';
import languageStore               from "stores/languageStore"

class Footer extends Component {
  
  handleBackToTop = () => {
    window.scrollTo( 0, 0 )
  }
  
  render() {

    const { currentLanguage } = languageStore

    return (
      <footer className="footer relative ">
      
      <Container>
      <div className="absolute right-1 top-1">
      <BackToTop onClick={this.handleBackToTop}/>
      </div>
      <div className="pt4 pb1">
      <WordPressContainer postType="shop" slug={currentLanguage === "de" ? "footer" : "footer_EN"} />
      </div>
        
      </Container>
      
      <SocketMenu/>
      <div className="pb3 pt3" style={{backgroundColor: "#353434"}}>
      <Container>
      <Responsive minWidth={768}>
      <Menu borderless secondary pointing className={"w-100 "} style={{maxHeight: "50px", border: "none", whiteSpace: "nowrap", overflowX: "auto", overflowY: "hidden"}}>

      <Menu.Menu position="left" className=" black-70 " style={{borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px"}}>
      <Menu.Item as={NavLink} to={"/cms/impressum"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
      <p className="white">{translate("Impressum")}</p>
      </Menu.Item>
      <Menu.Item as={NavLink} to={"/cms/cookies"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
      <p className="white">{translate("Cookie-Einstellungen")}</p>
      </Menu.Item>
      <Menu.Item as={NavLink} to={"/cms/datenschutz"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
      <p className="white">{translate("Datenschutz")}</p>
      </Menu.Item>
      <Menu.Item as={NavLink} to={"/cms/agb"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
      <p className="white">{translate("AGB")}</p>
      </Menu.Item>
      <Menu.Item as={NavLink} to={"/cms/widerrufsbelehrung"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
      <p className="white">{translate("Widerruf & Retouren")}</p>
      </Menu.Item>
      </Menu.Menu>

      <Menu.Menu position="right" >
      <Menu.Item className=" white" style={{ display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px"}}>
      <p className="white">© 2025 Trendsoft GmbH. Alle Rechte vorbehalten.</p>
      </Menu.Item>

      </Menu.Menu>


      </Menu>
      </Responsive>
      <Responsive maxWidth={767}>
      <Menu borderless secondary pointing className={"w-100 "} style={{maxHeight: "50px", border: "none", overflowX: "auto", overflowY: "hidden", whiteSpace: "nowrap"}}>

    <Menu.Menu position="left" className=" black-70 " style={{borderRadius: "25px", display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px"}}>
    <Menu.Item as={NavLink} to={"/cms/impressum"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
    <p className="white">{translate("Impressum")}</p>
    </Menu.Item>
    <Menu.Item as={NavLink} to={"/cms/cookies"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
    <p className="white">{translate("Cookie-Einstellungen")}</p>
    </Menu.Item>
    <Menu.Item as={NavLink} to={"/cms/datenschutzerklaerung"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
    <p className="white">{translate("Datenschutz")}</p>
    </Menu.Item>
    <Menu.Item as={NavLink} to={"/cms/agb"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
    <p className="white">{translate("AGB")}</p>
    </Menu.Item>
    <Menu.Item as={NavLink} to={"/cms/widerrufsbelehrung"} activeStyle={{ color: "#ffffff", textDecoration: "none", border: "none" }}>
    <p className="white">{translate("Widerruf & Retouren")}</p>
    </Menu.Item>
    </Menu.Menu>

    <Menu.Menu position="right" >
    <Menu.Item className=" white" style={{ display: "flex", alignItems: "center", justifyContent: "center", vertical: "middle", maxHeight: "40px"}}>
    <p className="white">© 2025 Heinz Herenz Medizinalbedarf GmbH</p>
    </Menu.Item>

    </Menu.Menu>


    </Menu>
      </Responsive>

      </Container>
      </div>
      </footer>
    )
  }
}

const BackToTop = ( { onClick } ) => {
  return (
    <div className="pt3"><Button   basic onClick={onClick} icon={"chevron up"}/></div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Footer/Footer.js